import { RetailerApiClient } from '@/services/RetailerApiClient.js'

export default {
  getStatus(machineId) {
    return RetailerApiClient.get(`machines/car-sales-application/${machineId}/status`)
  },

  submitPersonalInfo(machineId, payload) {
    return RetailerApiClient.post(`machines/car-sales-application/${machineId}/personal-info-submitted`, payload)
  },

  submitAddressInfo(machineId, payload) {
    return RetailerApiClient.post(`machines/car-sales-application/${machineId}/address-info-submitted`, payload)
  },

  submitEmploymentInfo(machineId, payload) {
    return RetailerApiClient.post(`machines/car-sales-application/${machineId}/employment-info-submitted`, payload)
  },

  submitCustomerInfo(machineId) {
    return RetailerApiClient.post(`machines/car-sales-application/${machineId}/customer-info-submitted`)
  },

  editPersonalInfo(machineId) {
    return RetailerApiClient.post(`machines/car-sales-application/${machineId}/edit-personal-info`)
  },

  editAddressInfo(machineId) {
    return RetailerApiClient.post(`machines/car-sales-application/${machineId}/edit-address-info`)
  },

  editEmploymentInfo(machineId) {
    return RetailerApiClient.post(`machines/car-sales-application/${machineId}/edit-employment-info`)
  }
}
